<template>
  <div class="radio radio-custom">
    <!-- <label  :for="id + '-' + idx" :class="innerClass"> -->
    <BFormRadio
      v-for="(option, idx) in optionsAll"
      v-show="!disabled || radioSelected == option.id"
      :id="id + '-' + idx"
      :key="idx"
      v-model="radioSelected"
      :name="id"
      :value="option.id"
      :class="classes"
      :disabled="disabled"
    >
      {{ option.name }}
      <span v-if="aria">{{ aria }}</span>
      <BaseControlHelp
        v-if="option.help"
        :id="`${id}-${idx}`"
        :help="option.help"
      />
    </BFormRadio>

    <!-- <span v-if="aria">{{aria}}</span> -->
    <!-- </label> -->
  </div>
</template>

<script>
import map from "lodash/map";
import filter from "lodash/filter";
import BaseControlHelp from "../Elements/BaseControlHelp";

const _ = { map, filter };

export default {
  name: "BaseRadio",
  components: {
    BaseControlHelp
  },
  props: {
    id: { type: String, required: true },
    value: { required: true },
    aria: { type: String, required: false },
    options: {
      type: Array,
      required: true
    },
    asObject: { type: Boolean, default: false },
    innerClass: { type: [String, Object], default: "" },
    any: { type: [Boolean], default: false },
    anyName: { type: String, default: "Dowolne" },
    error: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      radioSelected: null //checked
    };
  },
  computed: {
    optionsAll: function() {
      return this.any === true && this.options[0].id !== ""
        ? [{ id: "", name: this.anyName }, ...this.options]
        : this.options;
    },
    hasError() {
      return this.error ? true : false;
    },
    classes() {
      return {
        "is-invalid": this.hasError
      };
    }
  },
  watch: {
    value: {
      handler: function(newValue, oldValue) {
        this.setData(newValue);
      },
      deep: true
    },
    radioSelected: function() {
      if (this.asObject) {
        let s = _.filter(this.optionsAll, v => v.id == this.radioSelected);
        this.$emit("input", s[0]);
      } else {
        this.$emit("input", this.radioSelected);
      }
    }
  },
  created() {
    this.setData(this.value);
  },
  methods: {
    setData: function(newValue) {
      if (this.asObject) {
        if (newValue.id != this.radioSelected) {
          let s = _.filter(this.optionsAll, v => v.id == newValue.id);
          this.radioSelected = s[0].id;
        }
      } else {
        if (newValue != this.radioSelected) {
          this.radioSelected = newValue;
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.custom-control-label::before {
  border-color: $col-polmed-gray;
}

.custom-radio.is-invalid label:before {
  border-color: $col-polmed-red;
}

.custom-control-input:checked ~ .custom-control-label::before {
  border-color: $col-polmed-blue;
  background-color: $col-polmed-blue;
}

.custom-control-input:disabled ~ .custom-control-label::before {
  background: none;
  border-color: $col-polmed-gray;
}

.custom-radio
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: $col-polmed-gray2;
  border-color: $col-polmed-gray2;
}
</style>
